export enum EPlayerType {
  Player,
  Spectator
}
